(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.header.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.header.js');
"use strict";

const {
  clx
} = svs.components.lbUtils;
const {
  TableRow
} = svs.components.tipsen.tipsinfo.tableComponents;
const TableHeader = _ref => {
  let {
    children,
    className
  } = _ref;
  return React.createElement("thead", {
    className: clx('tipsinfo_table__header', className)
  }, children);
};
TableHeader.Row = TableRow;
setGlobal('svs.components.tipsen.tipsinfo.tableComponents.TableHeader', TableHeader);

 })(window);